import { useEffect, useState } from "react";
import api, { formatAxiosError } from "@/lib/api";
import { FloppyDisk, Coins } from "@phosphor-icons/react";

export default function ReferralsConfigTab() {
  const [cfg, setCfg] = useState({ default_reward_amount: 500, reward_currency: "USD" });
  const [msg, setMsg] = useState({ type: "", text: "" });
  const [saving, setSaving] = useState(false);

  useEffect(() => { (async () => {
    try { const r = await api.get("/referrals/config"); setCfg(r.data); }
    catch (e) { setMsg({ type: "error", text: formatAxiosError(e) }); }
  })(); }, []);

  const save = async () => {
    setSaving(true); setMsg({ type: "", text: "" });
    try {
      const r = await api.put("/referrals/config", {
        default_reward_amount: Number(cfg.default_reward_amount || 0),
        reward_currency: (cfg.reward_currency || "USD").toUpperCase(),
      });
      setCfg(r.data);
      setMsg({ type: "ok", text: "Referral config saved." });
      setTimeout(() => setMsg({ type: "", text: "" }), 4000);
    } catch (e) {
      setMsg({ type: "error", text: formatAxiosError(e) });
    } finally { setSaving(false); }
  };

  return (
    <div className="max-w-2xl space-y-6">
      <div>
        <div className="flex items-center gap-2 mb-1"><Coins size={16} weight="bold" className="text-[#002FA7]" />
          <h3 className="font-display text-xl font-black">Default reward</h3>
        </div>
        <p className="text-sm text-muted-foreground">This amount pre-fills the reward for each new referral when they get hired. It can be overridden per referral by HR/managers.</p>
      </div>
      {msg.text && (
        <div className={`text-xs px-3 py-2 border ${msg.type === "ok" ? "border-green-500 bg-green-50 text-green-700" : "border-red-500 bg-red-50 text-red-700"}`}>
          {msg.text}
        </div>
      )}
      <div className="grid grid-cols-2 gap-4">
        <label className="block">
          <span className="block text-xs font-mono-mini uppercase tracking-widest text-muted-foreground mb-1">Reward amount</span>
          <input type="number" min="0" step="any" className="input" value={cfg.default_reward_amount} onChange={(e) => setCfg({ ...cfg, default_reward_amount: e.target.value })} data-testid="cfg-reward-amount" />
        </label>
        <label className="block">
          <span className="block text-xs font-mono-mini uppercase tracking-widest text-muted-foreground mb-1">Currency</span>
          <input className="input uppercase" maxLength={8} value={cfg.reward_currency} onChange={(e) => setCfg({ ...cfg, reward_currency: e.target.value })} data-testid="cfg-currency" />
        </label>
      </div>
      <button onClick={save} disabled={saving} className="btn-primary flex items-center gap-2" data-testid="cfg-save">
        <FloppyDisk size={14} weight="bold" /> {saving ? "Saving…" : "Save"}
      </button>
    </div>
  );
}
